import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OrganismHeatingFormProps } from '../../../model/global'

const initialState: OrganismHeatingFormProps['translations'] = {}

const translationsSlice = createSlice({
	name: 'translationsSlice',
	initialState,
	reducers: {
		initTranslations(state, { payload }: PayloadAction<OrganismHeatingFormProps['translations']>) {
			// state = payload
			return payload
		},
	},
})

export const translationsActions = translationsSlice.actions
export default translationsSlice.reducer
